/**
 * Purpose API Service
 *
 * Domain specific service for purpose listing APIs.
 * Always uses httpClient to preserve interceptors and token rotation.
 */

import { httpClient } from './http-client.service';
import type {
  PurposeListResponse,
  PurposeQueryParams,
} from '../types/purpose';

class PurposeAPIService {
  /**
   * Fetch paginated purpose list.
   *
   * @param params - pagination payload { limit, pageno }
   */
  async getPurposes(params: PurposeQueryParams): Promise<PurposeListResponse> {
    try {
      const response = await httpClient.post<PurposeListResponse>(
        'purposelist',
        params
      );

      return response.data;
    } catch (error) {
      console.error('[PurposeAPI] Failed to fetch purposes:', error);
      throw error;
    }
  }
}

export const purposeAPI = new PurposeAPIService();
